import axios from "axios";
const state = {
    lives:[],
    lives_page:[],
    vialidades:[],
    vialidades_page:[],
};
const getters = {};

const actions = {
    getLives({commit}, values){
        axios.get(process.env.VUE_APP_BACKEND_ROUTE + "api/v1/live?page=" + values.page + values.filters).then(response => {
            commit('setLives', response.data.data);
            commit('setLivesPage', response.data.meta.last_page);
        });
    },
    getVialidades({commit}, values){
        axios.get(process.env.VUE_APP_BACKEND_ROUTE + "api/v1/live?filter[type]=vialidad&page=" + values.page + (values.filters || '')).then(response => {
            commit('setVialidades', response.data.data);
            commit('setVialidadesPage', response.data.meta.last_page);
        });
    }
};

const mutations = {
    setLives(state, data){
        state.lives = data;
    },
    setVialidades(state, data){
        state.vialidades = data;
    },
    setLivesPage(state, data){
        state.lives_page = data;
    },
    setVialidadesPage(state, data){
        state.vialidades_page = data;
    }
};

export default{
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}